import styled from 'styled-components/macro'
import Box from 'components/shared/Box'

interface SinglePhotoProps {
    photoPath: string
    alt: string
    isFullWidth?: boolean
}

const SinglePhotoWrapper = styled(Box)`
    background-size: cover;
    max-height: 100%;
    > img {
        border-radius: 8px;
        object-position: center;
        width: 100%;
    }
`

const SinglePhoto = ({ photoPath, alt, isFullWidth }: SinglePhotoProps) => (
    <SinglePhotoWrapper isFullWidth={isFullWidth}>
        <img src={photoPath} loading="lazy" alt={alt} />
    </SinglePhotoWrapper>
)

export default SinglePhoto
